import { useEffect } from "react";
import confetti from "canvas-confetti";

interface ConfettiCelebrationProps {
  trigger: boolean;
  onComplete?: () => void;
}

const ConfettiCelebration = ({ trigger, onComplete }: ConfettiCelebrationProps) => {
  useEffect(() => {
    if (!trigger) return;

    // Fire confetti from multiple angles
    const duration = 3000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

    const randomInRange = (min: number, max: number) => {
      return Math.random() * (max - min) + min;
    };

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        clearInterval(interval);
        onComplete?.();
        return;
      }

      const particleCount = 50 * (timeLeft / duration);

      // Cyan and silver confetti to match theme
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        colors: ["#00F2FF", "#C0C0C0", "#00D4FF", "#FFFFFF"],
      });
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
        colors: ["#00F2FF", "#C0C0C0", "#00D4FF", "#FFFFFF"],
      });
    }, 250);

    // Initial big burst
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: ["#00F2FF", "#C0C0C0", "#00D4FF", "#FFFFFF"],
      zIndex: 9999,
    });

    return () => clearInterval(interval);
  }, [trigger, onComplete]);

  return null;
};

export default ConfettiCelebration;
